// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js?minimize!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-000860f5\",\"scoped\":false,\"hasInlineConfig\":false}!../../less-loader/dist/cjs.js!../../vue-loader/lib/selector.js?type=styles&index=0!./tree.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("21d80007", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-000860f5","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-jstree/src/tree.vue
// module id = 15
// module chunks = 0